var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{staticClass:"news-detail-container",attrs:{"native":false}},[_c('div',{staticClass:"news-detail"},[_c('div',{staticClass:"news-title"},[_vm._v(_vm._s(_vm.newsInfo.title))]),_c('div',{staticClass:"news-content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.newsInfo.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }